<template>
  <el-empty description="该功能将在后续主干迭代中开放" />
</template>

<script>
export default {
  name: 'Placeholder'
}
</script>
